import * as React from "react";
import { Leaves } from "../../../libs/types";

export const handleReset = <Entity,>(
  clearFilters: () => void,
  dataIndex:  Leaves<Entity>,
  setSearchText: React.Dispatch<React.SetStateAction<{ [p: string]: string }>>,
) => {
  clearFilters()
  setSearchText((prev) => {
    delete prev[dataIndex]
    return {
      ...prev,
    }
  })
}
